<template>
  <div id="memberList">
    <div class="tableheader">
      <el-button @click="editGoods(-1)" class="btn1" type="primary" size="small">+{{$t("member").btn_add}}</el-button>
      <el-button @click="deleteGoods" class="btn_blue_boder" type="primary" size="small">{{$t("delete_select")}}</el-button>
	  <el-button v-if="isBan" @click="lockSelectGoods('lock')" class="btn_blue_boder" type="primary" size="small">{{$t("lock_select")}}</el-button>
      <el-button v-if="isBan" @click="lockSelectGoods('unlock')" class="btn_blue_boder" type="primary" size="small">{{$t("unlock_select")}}</el-button>
      <el-button @click="getList" class="btn3" type="primary" size="small">{{$t("search")}}</el-button>
      <el-input class="codeshearch" size="small" v-model="sForm.q" :placeholder="$i18n.t('member').keyword" ></el-input>
      <!-- <el-select @change="getList" v-model="sForm.status" placeholder="请选择" size="mini" style="float:right;margin-right:5px;width:100px">
        <el-option :label="$i18n.t('member').status_ok" :value="10"></el-option>
        <el-option :label="$i18n.t('member').status_notok" :value="11"></el-option>
      </el-select> -->
    </div>
    <div class="deviceAddBlock">
      <el-table :data="lists" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="user_id" label="ID" width="100"></el-table-column>
        <el-table-column :label="$i18n.t('member').name">
          <template slot-scope="scope">
            <div v-if="scope.row.nickname">{{scope.row.nickname}}</div>
            <div v-else-if="scope.row.user_acct">{{scope.row.user_acct}}</div>
            <div v-else>{{scope.row.mobile}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" :label="$i18n.t('member').mobile"></el-table-column>
        <el-table-column prop="shop" :label="$i18n.t('member').form_user_shop"></el-table-column>
        <el-table-column prop="pwd" :label="$i18n.t('member').password"></el-table-column>
		<el-table-column width="220" prop="last_login" :label="$i18n.t('member').last_login"></el-table-column>
		<el-table-column prop="last_device" :label="$i18n.t('member').last_device"></el-table-column>
		<el-table-column v-if="isBan" :label="$i18n.t('member').locktitle">
			<template slot-scope="scope">
			  <div>
				<span style="font-weight: bold;" v-if="scope.row.is_lock">[{{$t('member').lock}}]</span>
				<span style="font-weight: normal;" v-else>[{{$t('member').unlock}}]</span>
				<el-switch @change="changeLock($event, scope.row.user_id)" v-model="scope.row.lockstatus" active-color="#000000" inactive-color="#CCCCCC"></el-switch>
			  </div>
			</template>
		</el-table-column>
        <el-table-column prop="powername" :label="$i18n.t('member').form_user_power">
          <template slot-scope="scope">
            <div v-if="scope.row.power && scope.row.power.split(',').length > 0">
              <div v-for="k in scope.row.power.split(',')" :key="k">{{allAuths[k]}}&emsp;</div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column :label="$i18n.t('member').status">
          <template slot-scope="scope">
            <div v-if="scope.row.status==10">{{$t("member").status_ok}}</div>
            <div v-else>{{$t("member").status_notok}}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$i18n.t('contral')" width="200">
          <template slot-scope="scope">
            <el-button @click="editGoods(scope.row)" class="btn1" type="primary" size="mini">{{$t("edit")}}</el-button>
            <el-button @click="delGoods(scope.row.user_id)" class="btn_blue_boder" type="primary" size="mini">{{$t("delete")}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-show="showFlow"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="sForm.page"
        :page-sizes="[20, 50, 100, 200, 500]"
        :page-size="sForm.pageSize"
        layout="sizes,total, prev, pager, next"
        :total="sForm.total"
        style="margin-top: 0.0833rem"
      >
      </el-pagination>
    </div>
    <el-dialog :title="$i18n.t('member').delete_sure" :visible.sync="dialogVisible" width="30%">
      <span>{{$t("member").delete_tips}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn_blue_boder" @click="dialogVisible = false">{{$t("normal_cancle")}}</el-button>
        <el-button type="primary" @click="sureDelGoods">{{$t("normal_sure")}}</el-button>
      </span>
    </el-dialog>
	<el-dialog :title="$i18n.t('member').lock_sure" :visible.sync="dialogVisibleLock" width="30%">
	  <span>{{$t("member").lock_tips}}</span>
	  <span slot="footer" class="dialog-footer">
	    <el-button class="btn_blue_boder" @click="dialogVisibleLock = false">{{$t("normal_cancle")}}</el-button>
	    <el-button type="primary" @click="sureLockGoods">{{$t("normal_sure")}}</el-button>
	  </span>
	</el-dialog>
    <el-dialog :title="titleDialog" :visible.sync="dialogGoodsVisible" width="600px">
      <el-form :model="addForm">
        <el-form-item :label="$i18n.t('member').form_user_name" :label-width="formLabelWidth">
          <el-input v-model.trim="addForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('member').mobile" :label-width="formLabelWidth">
          <el-input v-model.trim="addForm.mobile"></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('member').form_user_shop" :label-width="formLabelWidth">
          <el-input v-model.trim="addForm.shop"></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('member').form_user_pwd" :label-width="formLabelWidth">
          <el-input v-model.trim="addForm.pwd"></el-input>
        </el-form-item>
		<el-form-item v-if="isBan" :label="$i18n.t('member').form_user_location" :label-width="formLabelWidth">
		  <el-input v-model.trim="addForm.location"></el-input>
		</el-form-item>
		<el-form-item v-if="isBan" :label="$i18n.t('member').form_user_level" :label-width="formLabelWidth">
		  <el-input v-model.trim="addForm.level"></el-input>
		</el-form-item>
        <el-form-item :label="$i18n.t('member').form_user_power" :label-width="formLabelWidth">
          <el-checkbox-group v-model.trim="powerarr" size="small">
            <el-checkbox v-for="(value,index) in allAuths" :label="index" border :key="index">{{value}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$i18n.t('member').form_user_status" :label-width="formLabelWidth">
          <el-radio v-model="addForm.status" :label="10">{{$i18n.t('member').status_ok}}</el-radio>
          <el-radio v-model="addForm.status" :label="11">{{$i18n.t('member').status_notok}}</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn_blue_boder" @click="dialogGoodsVisible = false">{{$t("normal_cancle")}}</el-button>
        <el-button type="primary" @click="subimtSave()">{{$t("normal_sure")}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'memberList',
  data () {
    return {
      formLabelWidth: '80px',
      showFlow: false,
      showadddefault: false,
      showdelfault: false,
      doing: false,
      sForm:{
        q: '',
        status: '',
        page: 1,
        pageSize: 20,
        total: 100
      },
      addForm: {
        id: '',
        name: '',
        mobile: '',
        pwd: '',
        status: '',
		location: '',
		level: ''
      },
      powerarr: [],
      oldData: null,
      lists: null,
      titleDialog: '',
      dialogVisible: false,
	  dialogVisibleLock: false,
	  lockpath: 'lock',
      ids: [],
      dialogGoodsVisible: false,
      allAuths:{
          "1":this.$i18n.t('buchong').member_powerlist[0],
          "2":this.$i18n.t('buchong').member_powerlist[1],
          "3":this.$i18n.t('buchong').member_powerlist[2],
          "4":this.$i18n.t('buchong').member_powerlist[3]
      },
	  isBan: false
    }
  },
  computed: {

  },
  created () {
	if(localStorage.locale !== 'zh'){
		this.formLabelWidth = '1.2rem'
	}
    if (sessionStorage.userlistParam) {
      this.sForm = JSON.parse(sessionStorage.userlistParam)
    }
    this.getList();
    this.initConf()
  },
  methods: {
	changeLock(event, id){
		console.log('changeLock', event)
		this.ids = []
		this.ids.push(id)
		this.lockpath = event?'lock':'unlock'
		this.sureLockGoods()
	},
    initConf () {
        let _this = this
        let data = {
            code: 'platform'
        };
        this.axios
            .post("/skinMgrSrv/config/get", this.formData(data))
            .then(function(response) {
                if (response.data.code === 0) {
                    if(response.data.platform&&response.data.platform=='zsmkj') {
                        _this.$set(_this.allAuths, '5', _this.$i18n.t('buchong').member_powerlist[4])
                    }
					if(response.data.platform&&response.data.platform=='ban') {
						_this.isBan = true
					}
                }
            }).catch(function (res) {
            console.error(res)
        });
    },
    handleSelectionChange(val) {
      this.ids = []
      if (val) {
        for(let i in val) {
          if(val[i].user_id) {
            this.ids.push(val[i].user_id)
          }
        }
      }
    },
    handleSizeChange (val) {
      this.sForm.page = 1
      this.sForm.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.sForm.page = val
      this.getList()
    },
    getList () {
      let dataLoadIng = this.openFullScreen()
      let _this = this
      let data = this.sForm
      this.axios.post('/skinMgrSrv/user/list', this.formData(data)).then(function (response) {
        if (response.data.code === 0) {
		  if(response.data.is_manager !== 1) {
			_this.$router.push({path: '/skinmgr/home'})
			return false
		  }
          sessionStorage.userlistParam = JSON.stringify(_this.sForm)
          _this.lists = response.data.list
          _this.sForm.total = response.data.total
          _this.showFlow = true
          _this.showadddefault = false
          _this.showdelfault = false
          if (response.data.hasdefault === 1) {
            _this.showdelfault = true
          }else{
            _this.showadddefault = true
          }
		  for(let _i in _this.lists){
			_this.lists[_i].lockstatus = _this.lists[_i].is_lock==1?true:false
		  }
        }else{
			_this.lists = null
			_this.sForm.total = 0
			_this.showFlow = false
			//_this.$message(response.data.msg)
		}
        setTimeout(() => {
          dataLoadIng.close()
        }, 600);
        console.log(response.data)
      }).catch(function(res){
		  dataLoadIng.close()
		  console.log(res)
	  })
    },
    delGoods (id) {
      this.ids = []
      this.ids.push(id)
      this.dialogVisible = true
    },
	lockGoods(id){
		this.ids = []
		this.ids.push(id)
		this.dialogVisibleLock = true
	},
	lockSelectGoods(path){
		//批量锁定
		if (this.ids.length < 1) {
		  this.$message(this.$i18n.t('member').select_to_lock)
		  return false
		}
		this.lockpath = path
		this.dialogVisibleLock = true
	},
    deleteGoods () {
		//批量删除
      if (this.ids.length < 1) {
        this.$message(this.$i18n.t('member').select_to_delete)
        return false
      }
      this.dialogVisible = true
    },
    sureDelGoods () {
		//提交删除
      if (this.doing === true) {
        return false
      }
      this.doing = true
      let _this = this
      let data = {
        'ids': this.ids
      }
      this.axios.post('/skinMgrSrv/user/delete', this.formData(data)).then(function (response) {
        _this.doing = false
        _this.dialogVisible = false
        if (response.data.code === 0) {
          _this.$message(_this.$i18n.t('member').deletesuccess)
          _this.getList()
        }
      }).catch(function (res) {
          _this.doing = false
      })
    },
	sureLockGoods () {
	  //提交锁定
	  if (this.doing === true) {
	    return false
	  }
	  this.doing = true
	  let _this = this
	  let data = {
	    'ids': this.ids
	  }
	  this.axios.post('/skinMgrSrv/user/'+this.lockpath, this.formData(data)).then(function (response) {
	    _this.doing = false
	    _this.dialogVisibleLock = false
	    if (response.data.code === 0) {
			if(_this.lockpath == 'lock'){
				_this.$message(_this.$i18n.t('member').locksuccess)
			}else{
				_this.$message(_this.$i18n.t('member').unlocksuccess)
			}
	      _this.getList()
	    }
	  }).catch(function (res) {
	      _this.doing = false
	  })
	},
    editGoods (user) {
      this.titleDialog = this.$i18n.t('member').btn_add
      if(user != -1){
        sessionStorage.oldUserData = JSON.stringify(user)
        this.addForm = user
        this.addForm.id = this.addForm.user_id
        this.addForm.oldpwd = this.addForm.pwd
        if(user.power){
          this.powerarr = user.power.split(',')
        }
        this.titleDialog = this.$i18n.t('member').edit
      }
      this.dialogGoodsVisible = true
    },
    subimtSave(){
      let _this = this
      let data = this.addForm
      data.powerarr = this.powerarr
      if(data.powerarr.length < 1){
        _this.$message(this.$i18n.t('member').form_message_power)
        return false
      }
      if(data.name == ''){
        _this.$message(this.$i18n.t('member').form_message_name)
        return false
      }
      if(data.mobile == ''){
        _this.$message(this.$i18n.t('member').form_message_mobile)
        return false
      }
      if(data.pwd == ''){
        _this.$message(this.$i18n.t('member').form_message_pwd)
        return false
      }
      if(data.shop == ''){
        _this.$message(this.$i18n.t('member').form_message_shop)
        return false
      }
      if(data.status == ''){
        _this.$message(this.$i18n.t('member').form_message_status)
        return false
      }
      if(data.id){
        this.oldData = JSON.parse(sessionStorage.oldUserData)
        if(data.name == this.oldData.nickname){
          data.name = ''
        }
        if(data.mobile == this.oldData.mobile){
          data.mobile = ''
        }
        if(data.pwd == this.oldData.pwd){
          data.pwd = ''
        }
		if(this.isBan){
			data.location = ''
			data.level = ''
		}else{
			if(data.location == this.oldData.location){
			  data.location = ''
			}
			if(data.level == this.oldData.level){
			  data.level = ''
			}
		}
        if(data.shop == this.oldData.shop){
          data.shop = ''
        }
        if(data.status == this.oldData.status){
          data.status = ''
        }
        if(this.oldData.power){
          if(data.powerarr == this.oldData.power.split(',')){
            data.powerarr = ''
          }
        }
      }
        if (this.doing === true) {
            return false
        }
        this.doing = true
      this.axios.post('/skinMgrSrv/user/save', this.formData(data)).then(function (response) {
        _this.doing = false
        _this.dialogGoodsVisible = false
        if (response.data.code === 0) {
		  if(response.data.is_manager !== 1) {
			_this.$router.push({path: '/skinmgr/home'})
			return false
		  }
          _this.addForm = {
            id: '',
            name: '',
            mobile: '',
            pwd: '',
            status: '',
			location: '',
			level: ''
          }
          _this.getList()
        }else{
          _this.$message(response.data.msg)
        }
      }).catch(function(res){
        _this.dialogGoodsVisible = false
        _this.doing = false
        console.log(res)
      })
    }
  }
}
</script>
<style  lang="scss">
  #memberList{
    .tabs-container {
      .el-card__header {
        padding: 0.0833rem 0.1667rem !important;
      }
      .el-card{
        cursor: pointer;
      }
      .el-card:hover{
        border: $blue 1px solid;
      }
    }
    .el-dialog__header{
      border-bottom: #E9E9E9 1px solid !important;
    }
    .el-button--primary {
      color: #fff;
      background-color: #57AEC9;
      border-color: #57AEC9;
    }
    .btn_blue_boder{
      border: #57AEC9 1px solid;
      color: #57AEC9;
      background-color: #ffffff;
    }
    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
      color: #fff;
      background-color: #57AEC9;
      border-color: #57AEC9;
      -webkit-box-shadow: -1px 0 0 0 #57AEC9;
      box-shadow: -1px 0 0 0 #57AEC9;
    }
    .dialog-footer-center{
      text-align: center;
    }
    .el-checkbox{
      margin-right: 0px;
    }
    .el-checkbox.is-bordered.el-checkbox--small .el-checkbox__inner {
      border-right: none;
      border-bottom: none;
      bottom: -14px;
      right: -73px;
      position: absolute;
	  display: none;
    }
    .el-input--mini .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
    .el-scrollbar__wrap {
      overflow: hidden;
    }
  }
  .el-scrollbar__wrap {
    overflow: hidden;
  }
</style>

<style lang="scss">
  #memberList {
    margin: 0.16rem;
    padding: 0.16rem;
    background-color: #fff;
    border-radius: 0.04rem;
    box-sizing: border-box;
    width: calc(100% - 0.48rem);
    .tableheader{
      margin-top: 0.0833rem;
    }
    p.title{
      height: 0.4167rem;
      line-height:0.4167rem;
      font-size:0.15rem;
      color:#000;
    }
    .btn2,.btn3{
      padding: 0.0667rem 0.0833rem;
    }
    .codeshearch{
      width: 1.667rem;
    }
    .btn3,.codeshearch{
      float: right;
      margin-right: 0.0833rem;
    }
    .codeshearch{
      width: 2.5rem;
    }
    .deviceAddBlock{
      margin-top: 0.0833rem;
    }
    .goods_name{
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .lh18{
      margin-bottom: 0.1rem;
      line-height: 180%;
    }
    .modelxls{
      position:absolute;
      border: 1px solid #ccc;
      top: 0.7rem;
      right: 0.2rem;
      width: 0.9rem;
      height: 1.2rem;
      text-align: center;
      padding-top: 0.1rem;
      a{
        margin-top: 0.1rem;
        border: 1px solid #ccc;
        height: 0.25rem;
        line-height: 0.25rem;
        border-radius: 0.15rem;
        width: 0.7rem;
        display: block;
        margin-left: 0.1rem;
      }
    }
    .uploadbutton{
      width: 100%;
      height: auto;
      margin-top: 0.5rem;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/members/list.vue